import axios from 'axios'
import { useAuthHeader } from 'react-auth-kit'
import { useState, useEffect } from 'react'
import { Link, useParams } from 'react-router-dom'
// import AddButton from '../../usables/small/AddButton'
import Table from '../../usables/Table'
// import Input from '../../usables/small/Input'
// import Modal from '../../usables/Modal'
import Spinner from '../../usables/small/Spinner'
import ClosingAlert from '../../usables/Alert'

export default function Class() {
  const { id } = useParams();
  const auth  = useAuthHeader()
  const [classs, setClasss] = useState([])
  const [dataLoaded, setDataLoaded] = useState({done: false, sucssess: false, items: 0})

  const tableColumns = [{
    Header: "Moksleiviai",
    columns: [
      {
        Header: "Vardas",
        accessor: "person.name"
      },
      {
        Header: "Pavardė",
        accessor: "person.lastname"
      },
      {
        Header: "Pažymys",
        accessor: "avg_grade"
      },
      {
        Header: "Veiksmai",
        accessor: "action"
      },
    ]
  }]

  const config = {
    headers: {
      Authorization: auth()
    }
  }
  useEffect(() => {
    axios.get(process.env.REACT_APP_API + `/class/students/${id}`, config)
    .then(res => {
      if(res.status === 200){
        //console.log(...res.data)
        setClasss([]) //! Pašalinti prieš buildinant
        res.data.students.forEach((data) => {
          console.log(data)
          data.action = <Link className='text-violet-500 hover:text-violet-700' to={'/dashboard/students/' + data.id}>Daugiau</Link>
          setClasss(guardians => [...guardians, data])
        })
        setDataLoaded({done: true, sucssess: true, items: res.data.students.length})
      }
    })
    .catch(err => {
      setClasss([]) //! Pašalinti prieš buildinant
      //console.log(err.response.data)
      setClasss(guardians => [...guardians, err.response.data])
      setDataLoaded({done: true, sucssess: false, items: 0})
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
    <h2>Klasė </h2>
      {!dataLoaded.done
      ? <Spinner />
      : dataLoaded.sucssess
        ?dataLoaded.items
          ? <Table columns={tableColumns} data={classs} />
          : <ClosingAlert type='warning' message='Klasėje mokinių nėra' />
        : <ClosingAlert type='error' message='Klasė nerasta' />
      }
    
    {/* <Modal showAddBtn={true} title='Pridėti moksleivį' saveText='Sukurti' submitFunction={() => {}}>
      <div className='pt-5'>
        <Input
          label='Numeris'
          name='name'
          type='text'
          />
        <Input
          label='Dalykas'
          name='subject_name'
          type='text'
          />
        </div>
      </Modal> */}
    </>
  )
}